import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiWindows,
  SiFigma,
  SiCanva,
  SiLinux,
  SiSupabase,
  SiDocker,
  SiTrello,
  SiAndroidstudio,
  SiAtlassian,
} from "react-icons/si";

/**
 * Reusable wrapper for one icon + tooltip (JS/JSX version)
 */
function ToolIcon({ label, children }) {
  return (
    <Col xs={4} md={2} className="tech-icons">
      <OverlayTrigger
        placement="top"
        delay={{ show: 120, hide: 80 }}
        overlay={<Tooltip id={`tooltip-${label}`}>{label}</Tooltip>}
      >
        {/* Must be a single child element for OverlayTrigger */}
        <span
          style={{ display: "inline-flex", cursor: "default" }}
          aria-label={label}
        >
          {children}
        </span>
      </OverlayTrigger>
    </Col>
  );
}

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <ToolIcon label="Windows">
        <SiWindows />
      </ToolIcon>

      <ToolIcon label="Visual Studio Code">
        <SiVisualstudiocode />
      </ToolIcon>

      <ToolIcon label="Android Studio">
        <SiAndroidstudio />
      </ToolIcon>

      <ToolIcon label="Supabase">
        <SiSupabase />
      </ToolIcon>

      <ToolIcon label="Docker">
        <SiDocker />
      </ToolIcon>

      <ToolIcon label="Figma">
        <SiFigma />
      </ToolIcon>

      <ToolIcon label="Linux">
        <SiLinux />
      </ToolIcon>

      <ToolIcon label="Atlassian">
        <SiAtlassian />
      </ToolIcon>

      <ToolIcon label="Canva">
        <SiCanva />
      </ToolIcon>

      <ToolIcon label="Trello">
        <SiTrello />
      </ToolIcon>
    </Row>
  );
}

export default Toolstack;
